import { connect } from "react-redux";
import { SearchFilter as Filter } from "MODULES/shared/components";
import { parse } from "query-string";

export default connect(
  () => ({
    initialFilter: parse(location.search).filter
  }),
  (dispatch, { search }) => ({
    onSubmit: filter => dispatch(search.setFilter("filter", filter))
  })
)(Filter);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Pagination/SearchFilter.jsx